var map = {
	"./adesivo-veloe.png": 620,
	"./alterarSenha.png": 394,
	"./avatar.png": 1879,
	"./avatars/avatar-1.png": 240,
	"./avatars/avatar-2.png": 241,
	"./avatars/avatar-3.png": 242,
	"./avatars/avatar-4.png": 243,
	"./avatars/avatar-5.png": 244,
	"./avatars/avatar-6.png": 245,
	"./avatars/avatar-7.png": 246,
	"./avatars/avatar-8.png": 247,
	"./avatars/avatar-pj.png": 387,
	"./bg-modal-desligamento.png": 621,
	"./blocked-car.png": 622,
	"./cancelAccount.png": 1880,
	"./car.png": 623,
	"./carro-veloe.png": 624,
	"./close-icon.png": 625,
	"./close.png": 1881,
	"./confirmation.png": 49,
	"./contestacao.png": 47,
	"./fuel.png": 1882,
	"./ic-arrow-blue-left.png": 626,
	"./ic-check.png": 612,
	"./ic-check@2x.png": 1883,
	"./ic-check@3x.png": 1884,
	"./ic-picker-plus.png": 1885,
	"./ic-search.png": 627,
	"./iconDownload.png": 1886,
	"./iconPrint.png": 1887,
	"./iconShare.png": 1888,
	"./irrf-auto-retencao.png": 628,
	"./login.png": 396,
	"./logoVeloe.png": 397,
	"./mail-to.png": 256,
	"./mail-to@2x.png": 1889,
	"./mail-to@3x.png": 1890,
	"./modalBuddies.png": 605,
	"./modalBuddies@2x.png": 1891,
	"./modalBuddies@3x.png": 1892,
	"./park.png": 1893,
	"./perfil-1@2x.png": 1894,
	"./perfil-1@3x.png": 1895,
	"./recarga.png": 254,
	"./semaphore.png": 609,
	"./tag_veloe@2x.png": 629,
	"./toll.png": 1896,
	"./truck-travel.png": 607,
	"./truck-travel@2x.png": 1897,
	"./truck-travel@3x.png": 1898,
	"./unblocked-car.png": 630
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1878;


//////////////////
// WEBPACK FOOTER
// ./src/static ^\.\/.*\.png$
// module id = 1878
// module chunks = 0